import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Lic. Martina Gómez',
  location: 'Buenos Aires',
  age: 32,
  text: 'Me cambió completamente la dinámica del consultorio. Ahora resuelvo casos complejos con mucha más confianza y mis pacientes notan la diferencia.',
  rating: 5
}, {
  name: 'Lic. Camila Rossi',
  location: 'Córdoba',
  age: 28,
  text: 'Ahorro como 3 horas por semana en armar planes y protocolos. Todo está súper organizado y listo para usar. Lo recomiendo 100%.',
  rating: 5
}, {
  name: 'Lic. Sofía Álvarez',
  location: 'Rosario',
  age: 35,
  text: 'Los casos clínicos resueltos son oro puro. Finalmente tengo un sistema que funciona y que puedo replicar con todos mis pacientes.',
  rating: 5
}, {
  name: 'Lic. Valentina Pereyra',
  location: 'Mendoza',
  age: 29,
  text: 'Las planillas de seguimiento son increíbles. Mis pacientes tienen mucha mejor adherencia y yo puedo hacer un seguimiento mucho más profesional.',
  rating: 5
}, {
  name: 'Lic. Julieta Fernández',
  location: 'La Plata',
  age: 41,
  text: 'Después de años trabajando, este sistema me ordenó todo. Ahora trabajo más rápido, mejor y con resultados que antes me costaba lograr.',
  rating: 5
}];
export function Testimonials() {
  return <section className="w-full py-16 md:py-24 bg-gradient-to-b from-emerald-50 to-white" data-id="element-256">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-258">
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-259">
            Lo que dicen{' '}
            <span className="text-emerald-600" data-id="element-260">las nutricionistas</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-261">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-emerald-100" data-id="element-262">
              <div className="flex items-center gap-4 mb-4" data-id="element-263">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center text-white font-bold text-xl" data-id="element-264">
                  {testimonial.name.split(' ')[1][0]}
                </div>
                <div data-id="element-265">
                  <div className="font-bold text-slate-900" data-id="element-266">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-slate-600" data-id="element-267">
                    {testimonial.location}
                  </div>
                </div>
              </div>

              <div className="flex gap-1 mb-4" data-id="element-268">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-269" />)}
              </div>

              <p className="text-slate-700 leading-relaxed" data-id="element-270">
                "{testimonial.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}